import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import AdminLayout from "./components/Layout/AdminLayout";
import SplashScreen from "./pages/SplashScreen";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Forgotpass from "./pages/Forgotpass";
import OtpPage from "./pages/PassOtp";
import ResetPass from "./pages/ResetPass";
import UserProfileSetup from "./pages/UserProfileSetup";
import ProtectedRoute from "./routes/ProtectedRoute";
import PublicRoute from "./routes/PublicRoute";
import ProfileDone from "./pages/ProfileDone";
import IndentityandmealSetup from "./pages/IndentityandmealSetup";
import Addnewmeal from "./components/Modals/Addnewmeal";
import Mealdetail from "./pages/Mealdetail";
import Orderdelivery from "./pages/Orderdelivery";
import SetMenu from "./pages/SetMenu";
import Orderdetail from "./pages/Orderdetail";
import Orderedit from "./pages/Orderedit";
import Customers from "./pages/Customers";
import Detail from "./pages/customerspages/Detail";
import SubscribeView from "./pages/customerspages/SubscribeView";
import Balanceview from "./pages/customerspages/Balanceview";
import Orderview from "./pages/customerspages/Orderview";
import Payment from "./components/Paymentview/Payment";
import AddnewOrder from "./pages/AddnewOrder";
import SingleDeliver from "./components/Tab/SubscribeTabpages/SingleDeliver";
import Addresslist from "./pages/Addresslist";
import Addnewaddress from "./pages/Addnewaddress";
import EditAddress from "./pages/EditAddress";
import Addnewcustomers from "./pages/Addnewcustomers";
import Order from "./pages/Order";
import Profile from "./pages/Profile";
import Personal from "./pages/Profilepages/Personal";
import EditService from "./pages/Profilepages/EditService";
import SubsciptionPlan from "./pages/Profilepages/SubsciptionPlan";
import SubsHistory from "./pages/Profilepages/SubsHistory";
import Supports from "./pages/Profilepages/Supports";
import Meals from "./pages/Profilepages/Meals";
import EditMeal from "./components/Modals/EditMeal";
import Mealplan from "./components/Tab/setUpPages/Mealplan";
import AddNewMeal from "./pages/Profilepages/AddNewMeal";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import ViewSubsPlan from "./pages/Profilepages/ViewSubsPlan";
import EditSubscriptionplan from "./pages/customerspages/EditSubscriptionplan";
import UpdatePickUpAddress from "./pages/Profilepages/UpdatePickUpAddress";
import { LoadScript } from "@react-google-maps/api";
import AddCustomerAddress from "./pages/customerspages/AddCustomerAddress";
import SubscriptionplanDetails from "./pages/customerspages/SubscriptionplanDetails";
import Inquiry from "./pages/Profilepages/Inquiry";
import Subscriptiondetails from "./pages/customerspages/Subscriptiondetails";
import EnvironmentTag from "./components/Tag/EnvironmentTag";
import GoBackBtn from "./components/GoBackBtn";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
function App() {
  const libraries = ["places"];

  return (
    <LoadScript
      googleMapsApiKey={import.meta.env.VITE_GOOGLE_API_KEY}
      libraries={libraries}
    >
      <EnvironmentTag />
      <GoBackBtn />
      <Routes>
        <Route
          path="/"
          element={
            <PublicRoute>
              <SplashScreen />
            </PublicRoute>
          }
        />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms-and-conditions" element={<Terms />} />
        <Route
          path="/login"
          element={
            <PublicRoute>
              {/* ✅ Wrap Login inside the provider */}
              <GoogleReCaptchaProvider
                reCaptchaKey="6Le-uj8gAAAAABNGm_JUwhAy3BpxVjzGs5duNbjU"
                scriptProps={{
                  async: true,
                  defer: true,
                  appendTo: "body",
                }}
              >
                <Login />
              </GoogleReCaptchaProvider>
            </PublicRoute>
          }
        />
        <Route
          path="/register"
          element={
            <PublicRoute>
              <Register />
            </PublicRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <PublicRoute>
              <Forgotpass />
            </PublicRoute>
          }
        />
        <Route
          path="/otp-varify"
          element={
            <PublicRoute>
              <OtpPage />
            </PublicRoute>
          }
        />
        <Route
          path="/reset-password"
          element={
            <PublicRoute>
              <ResetPass />
            </PublicRoute>
          }
        />
        <Route
          path="/set-up-profile"
          element={
            <PublicRoute>
              <UserProfileSetup />
            </PublicRoute>
          }
        />

        <Route
          path="/profile-created"
          element={
            <ProtectedRoute>
              <ProfileDone />
            </ProtectedRoute>
          }
        />
        <Route
          path="/set-up"
          element={
            <ProtectedRoute>
              <IndentityandmealSetup />
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-new-plan"
          element={
            <ProtectedRoute>
              <Addnewmeal />
            </ProtectedRoute>
          }
        />
        <Route
          path="/meal-detail/:mealId"
          element={
            <ProtectedRoute>
              <Mealdetail />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <Dashboard />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/customer"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <Customers />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/order"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <Order />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <Profile />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/order-delivery/:orderId"
          element={
            <ProtectedRoute>
              <Orderdelivery />
            </ProtectedRoute>
          }
        />
        <Route
          path="/set-up-menu"
          element={
            <ProtectedRoute>
              <SetMenu />
            </ProtectedRoute>
          }
        />
        <Route
          path="/order-details/:orderId"
          element={
            <ProtectedRoute>
              <Orderdetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-order/:orderId"
          element={
            <ProtectedRoute>
              <Orderedit />
            </ProtectedRoute>
          }
        />

        <Route
          path="/address/:customer_id"
          element={
            <ProtectedRoute>
              <Addresslist />
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-new-address"
          element={
            <ProtectedRoute>
              <Addnewaddress />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customers-detail/:customer_id"
          element={
            <ProtectedRoute>
              <Detail />
            </ProtectedRoute>
          }
        />

        <Route
          path="/subscription/:customer_id"
          element={
            <ProtectedRoute>
              <SubscribeView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/subscription/subscription-detail/:meal_plan_id"
          element={
            <ProtectedRoute>
              <Subscriptiondetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-subscription/:meal_plan_id"
          element={
            <ProtectedRoute>
              <EditSubscriptionplan />
            </ProtectedRoute>
          }
        />
        <Route
          path="/subscription-order-summery/:meal_plan_id"
          element={
            <ProtectedRoute>
              <SubscriptionplanDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/balance/:customer_id"
          element={
            <ProtectedRoute>
              <Balanceview />
            </ProtectedRoute>
          }
        />
        <Route
          path="/order-history/:customer_id"
          element={
            <ProtectedRoute>
              <Orderview />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payment-history/:customer_id"
          element={
            <ProtectedRoute>
              <Payment />
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-new-order"
          element={
            <ProtectedRoute>
              <AddnewOrder />
            </ProtectedRoute>
          }
        />
        <Route
          path="/single-order"
          element={
            <ProtectedRoute>
              <SingleDeliver />
            </ProtectedRoute>
          }
        />

        <Route
          path="/profile/personal-profile"
          element={
            <ProtectedRoute>
              <Personal />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile/edit-service"
          element={
            <ProtectedRoute>
              <EditService />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile/subscription-plan"
          element={
            <ProtectedRoute>
              <SubsciptionPlan />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile/view-plan"
          element={
            <ProtectedRoute>
              <ViewSubsPlan />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile/support"
          element={
            <ProtectedRoute>
              <Supports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile/inquiry"
          element={
            <ProtectedRoute>
              <Inquiry />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile/meals"
          element={
            <ProtectedRoute>
              <Meals />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile/meals/edit-meal/:mealId"
          element={
            <ProtectedRoute>
              <EditMeal />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile/meals/add-new-meal"
          element={
            <ProtectedRoute>
              <AddNewMeal />
            </ProtectedRoute>
          }
        />
        <Route
          path="/subscription-history"
          element={
            <ProtectedRoute>
              <SubsHistory />
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit-address/:address_id"
          element={
            <ProtectedRoute>
              <EditAddress />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customer/add-customers-address/:customer_id"
          element={
            <ProtectedRoute>
              <AddCustomerAddress />
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-new-customer"
          element={
            <ProtectedRoute>
              <Addnewcustomers />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile/update-pickup-address"
          element={
            <ProtectedRoute>
              <UpdatePickUpAddress />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </LoadScript>
  );
}

export default App;
